import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/user-subscriptions";


export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Details = async (values) => {
  return await axiosInstance(options).get(`${path}/details?_id=${values}`);
};

export const cancelSubscription = async (values) => {
  return await axiosInstance(options).patch(`${path}/cancel-subscription`, values);
};




